module.exports = "<div class=\"overflow\">\n  <input type=\"checkbox\"\n    id=\"{{myId}}\"\n    class=\"{{$root.styles.checkbox.basic}}\"\n    ng-model=\"ngModel\"\n    ng-change=\"myChange()\" />\n  <label for=\"{{myId}}\"\n    ng-bind-html=\"myLabel\">\n  </label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/inputs/myCheckbox.html
// module id = 1216
// module chunks = 0